import { PlayerDto } from '../Dtos/PlayerDto';

export class UpdateTurnHolderResponse {
    static Message = 'UpdateCurrentTurnPlayerResponse';

    public turnHolder: PlayerDto;

    constructor(turnHolder: PlayerDto) {
        this.turnHolder = turnHolder;
    }
}
